import { Key } from '../../hotkeys/KeyStrokes.ts';
import { HotkeyBase, LayoutPickerHotkeyNames } from '../../hotkeys/types.ts';

export const DefaultLayoutPickerHotKeys: Record<LayoutPickerHotkeyNames, HotkeyBase> = {
  [LayoutPickerHotkeyNames.FocusSearchKey]: {
    primary: Key.KeyF,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutPickerHotkeyNames.NewLayoutKey]: {
    primary: Key.KeyN,
    hotkeyModifier: { modifier: 'Shift' },
  },
  [LayoutPickerHotkeyNames.NewLayoutFromTemplateKey]: {
    primary: Key.KeyT,
    hotkeyModifier: { modifier: 'Shift' },
  },
};
